import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  reassignTask,
  skipTask,
  adjustTaskSLA,
} from '../../shared/services/taskService';
import type {
  TaskReassignPayload,
  TaskSkipPayload,
  TaskSLAAdjustPayload,
} from '../../shared/types/task';
import { invalidateOpsCenter } from '../../../lib/invalidateOpsCenter';

interface UseGestaoMutationsParams {
  onSuccess?: () => void;
}

export function useGestaoMutations(params?: UseGestaoMutationsParams) {
  const queryClient = useQueryClient();

  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: ['tasks'] });
    await queryClient.invalidateQueries({ queryKey: ['gestao'] });
    await queryClient.invalidateQueries({ queryKey: ['minha-mesa'] });
    await queryClient.invalidateQueries({ queryKey: ['execution'] });
    invalidateOpsCenter(queryClient);
    params?.onSuccess?.();
  };

  const reassignMutation = useMutation({
    mutationFn: (payload: TaskReassignPayload) => reassignTask(payload),
    onSuccess: invalidate,
  });

  const skipMutation = useMutation({
    mutationFn: (payload: TaskSkipPayload) => skipTask(payload),
    onSuccess: invalidate,
  });

  const adjustSLAMutation = useMutation({
    mutationFn: (payload: TaskSLAAdjustPayload) => adjustTaskSLA(payload),
    onSuccess: invalidate,
  });

  return {
    reassignTask: reassignMutation.mutateAsync,
    isReassigning: reassignMutation.isPending,

    skipTask: skipMutation.mutateAsync,
    isSkipping: skipMutation.isPending,

    adjustSLA: adjustSLAMutation.mutateAsync,
    isAdjustingSLA: adjustSLAMutation.isPending,
  };
}
